/** 저장된 워크스페이스 id 를 실제 목록에 맞춰 고른다.
 *
 * 저장된 id 가 목록에 없는 경우가 실제로 생긴다 — 같은 브라우저에서 다른 계정으로
 * 로그인하거나, 저장된 워크스페이스가 사라진 뒤다. 그때 조용히 첫 워크스페이스로
 * 되돌린다(없으면 null). 남의 워크스페이스 id 로 요청해 403 을 받는 것보다 낫다.
 */
export function resolveWorkspace<T extends { id: string }>(
  workspaces: T[],
  storedId: string | null,
): T | null {
  return workspaces.find((w) => w.id === storedId) ?? workspaces[0] ?? null;
}
